import image from '../../assets/images/Photo01.jpg';
import image1 from '../../assets/images/Photo02.jpg';
import image2 from '../../assets/images/Photo03.jpg';
import image3 from '../../assets/images/Photo04.jpg';

export const items = [
  {
    images: image,
    head: "The creative process behind Diana Etuk Design - A UX writing case study",
    body: "I am highly organized, motivated and disciplined with great integrity and the ability to work und",
    date: "14th June, 2020",
    highlight: "Ux Writing",
  },
  {
    images: image1,
    head: "Spread love - Pandemic Poem",
    body: "I am the guy who prefers to take the last bus home later at night for the sake of solitude. Looking at Jakarta’s road behind the window while having the two seats just for myself (^.^)",
    date: "14th June, 2020",
    highlight: "Spoken Word",
  },
  {
    images: image2,
    head: "The Maestrom - Flash Fiction",
    body: "I am highly organized, motivated and disciplined with great integrity and the ability to work und",
    date: "14th June, 2020",
    highlight: "Flash Fiction",
  },
  {
    images: image3,
    head: "The creative process behind Diana Etuk Design - A UX writing case study",
    body: "I am highly organized, motivated and disciplined with great integrity and the ability to work und",
    date: "14th June, 2020",
    highlight: "Ux Writing",
  },
  {
    images: image2,
    head: "Spread love - Pandemic Poem",
    body: "I am the guy who prefers to take the last bus home later at night for the sake of solitude. Looking at Jakarta’s road behind the window while having the two seats just for myself (^.^)",
    date: "14th June, 2020",
    highlight: "Spoken Word",
  },
  {
    images: image1,
    head: "The Maestrom - Flash Fiction",
    body: "I am highly organized, motivated and disciplined with great integrity and the ability to work und",
    date: "14th June, 2020",
    highlight: "Flash Fiction",
  }
]
export default items
